
<ng-container *ngIf="showPersonalizedConfigModal">
<ng-container *ngIf="!isAPIErrorResp; else showErrorMessage">
    <nz-modal [(nzVisible)]="dataTransFormService.enablePersonalizedInboxModal" nzTitle="Configure your personalized inbox view"
    (nzOnCancel)="dataTransFormService.enablePersonalizedInboxModal=false" (nzOnOk)="savepersonalisedInboxDetails();"
    nzOkText="{{'Save' | MMSTranslate}}" nzWidth="900px">
    <ng-container *nzModalContent>
      <div class="grid grid-2x grid-gap-20 personalizedInboxCardSec">
        <div class="example-container">
          <div class="flex flex-horiz-space-bw">
            <h3 class="heading">Available Data</h3>
            <button nz-button nzSize="small" (click)="selectAllAttributes()"><i nz-icon nzType="export"
                nzTheme="outline"></i>
              <span>Select All</span>
            </button>
          </div>
  
  
          <div class="example-list" [dndList] [dndModel]="inboxDataPointsSuperSet">
            <div *ngFor="let item of inboxDataPointsSuperSet ; let index=index" class="example-box" [dndType]="'item'"
              (dndMoved)="removeItem(item, inboxDataPointsSuperSet, 'ADD' , index)" [dndDraggable] [dndObject]="item">
              {{item.description}}
            </div>
          </div>
  
        </div>
  
        <div class="example-container">
          <h3 class="heading">Selected Data</h3>
  
          <div class="example-list" [dndList] [dndModel]="inboxDataPointsDefaultSet">
            <div *ngFor="let item of inboxDataPointsDefaultSet; let index=index" class="example-box" [dndType]="'item'"
              (dndMoved)="removeItem(item, inboxDataPointsDefaultSet, 'DELETE', index)" [dndDraggable] [dndObject]="item">
              <div>
                <label nz-checkbox [(ngModel)]="item.isSelected" nz-tooltip
                  nzTooltipTitle="Highlight this data on the inbox"
                  (ngModelChange)="inboxDataSelected($event)">{{item.description}}</label>
              </div>
            </div>
          </div>
 
        </div>
  
      </div>
    </ng-container>
  
  </nz-modal>
</ng-container>
</ng-container>

<ng-container *ngIf="!showPersonalizedConfigModal">
</ng-container>
<ng-template #showErrorMessage>
    <nz-result nzStatus="500" nzTitle="Unable to process request" [nzSubTitle]="APIErrorMsg"></nz-result>
</ng-template>